import React, { useState, useEffect } from "react";
import {
    MenuItem,
    Grid,
    Select,
    Paper,
    Typography,
    Button,
} from "@material-ui/core";
import { StyledHeader } from "../../../styles";
import Box from "@material-ui/core/Box";
import styled from "styled-components";

const LabelTypography = styled(Typography)`
    width: 150px !important;
    word-wrap: break-word;
`;
const InfoDiv = styled(Paper)`
    width: 100%;
    border: 0.5px solid #0188cc;
    margin-right: 15px;
    margin-top: 25px;
    box-shadow: "0 0 15px -2px #444444";
`;

const RegisteredAreasDepartments = (props) => {
    const [editingProfile, setEditing] = useState(false);
    const [userProfile, setUserProfile] = useState(props.userProfile);
    const [areas, setAreas] = useState(props.areas);
    const [departments, setDepartments] = useState(props.departments);

    useEffect(() => {
        setAreas(props.areas);
    }, [props.areas]);
    useEffect(() => {
        setDepartments(props.departments);
    }, [props.departments]);
    useEffect(() => {}, []);

    return (
        <InfoDiv>
            <StyledHeader
                style={{
                    height: "fit-content",
                    width: "100%",
                    backgroundColor: "#0188cc",
                }}
            >
                <Box display="flex">
                    <Box flexGrow={1}>
                        <Typography
                            variant="display1"
                            style={{ color: "white" }}
                        >
                            Registered Areas & Departments
                        </Typography>
                    </Box>
                    <Box style={{ paddingRight: "15px" }}>
                        <Button
                            variant="contained"
                            size="small"
                            style={{
                                backgroundColor: "#FFA500",
                                color: "white",
                                maxHeight: "25px",
                            }}
                            onClick={() => {
                                setEditing((edit) => !edit);
                                setUserProfile(props.userProfile);
                            }}
                        >
                            {editingProfile ? "Cancel Edit" : "Edit"}
                        </Button>
                    </Box>
                </Box>
            </StyledHeader>
            <Grid
                container
                spacing={3}
                style={{ display: "inlineBlock", margin: 12 }}
            >
                <Grid
                    item
                    xs={4}
                    //style={{ display: "grid", justifyContent: "center" }}
                >
                    {editingProfile ? (
                        <div style={{ marginLeft: "5px" }}>
                            <LabelTypography variant="title" for="department">
                                Departments: 
                            </LabelTypography>
                            <br />
                            <Select
                                id="department"
                                multiple
                                value={userProfile.departments || []}
                                style={{ width: "180px" }}
                                onChange={(event) => {
                                    setUserProfile({
                                        ...userProfile,
                                        departments: event.target.value,
                                    });
                                }}
                            >
                                {departments &&
                                    Object.keys(departments).map((e, key) => {
                                        return (
                                            <MenuItem
                                                key={key}
                                                value={departments[e]}
                                            >
                                                {departments[e]}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </div>
                    ) : (
                        renderValues("Departments:", userProfile["departments"])
                    )}
                </Grid>

                <Grid
                    item
                    xs={4}
                    //style={{ display: "grid", justifyContent: "center" }}
                >
                    {editingProfile ? (
                        <>
                            <div>
                                <LabelTypography variant="title" for="area">
                                   Area's:
                                </LabelTypography>
                                <br />
                                <Select
                                    id="area"
                                    multiple
                                    value={userProfile.areas || []}
                                    style={{ width: "180px" }}
                                    onChange={(event) => {
                                        setUserProfile({
                                            ...userProfile,
                                            areas: event.target.value,
                                        });
                                    }}
                                >
                                    {areas &&
                                        Object.keys(areas).map((e) => {
                                            return (
                                                <MenuItem
                                                    key={e}
                                                    value={areas[e]}
                                                >
                                                    {areas[e]}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </div>
                            <br />
                            
                        </>
                    ) : (
                        renderValues("Area's: ", userProfile["areas"])
                    )}
                </Grid>
                <Grid
                    item
                    xs={4}
                    //style={{ display: "grid", justifyContent: "center" }}
                >
                    {editingProfile ?
                    <Button
                                disabled={props.canUpdate === false}
                                onClick={() => {
                                    props.submitUpdatedProfile(userProfile);
                                    setEditing(false);
                                }}
                                variant="contained"
                                style={{
                                    marginTop: 60,
                                    background: "#0188cc",
                                    color: "white",
                                    maxWidth:"55px",
                                    marginLeft: "60px"
                                }}
                            >
                                Save
                    </Button> : '' }
                </Grid>
            </Grid>
        </InfoDiv>
    );
};

const renderValues = (label, value) => {
    return (
        <div style={{ padding: "5px", marginLeft: "10px" }}>
            <LabelTypography variant="title" style={{ color: "#0188cc" }}>
                <b>{label} </b> <br />
            </LabelTypography>
            <Typography
                style={{ marginRight: "30px", wordWrap: "break-word" }}
                variant="title"
            >
                {typeof value === "object"
                    ? value.map((e, i) => {
                          return (
                              <span>
                                  {e} {value[i + 1] ? ", " : ""}
                              </span>
                          );
                      })
                    : value}
            </Typography>
        </div>
    );
};
export default RegisteredAreasDepartments;
